<template>
  <div class="clazz_manage_list">
    <div v-lazy:background-image="pageCover" class="page_cover">
      <div class="my">
        <img v-lazy="userprofile.avatar_url" class="headimg">
        <p>我的班级</p>
      </div>
    </div>

    <div v-for="(item, index) in list" :key="index" v-lazy:background-image="item.cover_url" class="clazz_panel" @click="gotoManageClazz(item)">
      <div class="bg">
        <div class="title">{{ item.clazz_name }}</div>
        <div class="detail">
          参与时间：{{ item.start_time_format2 }} ～ {{ item.end_time_format2 }}
          <!-- {{ item.start_time_format2 }} ~ {{ item.end_time_format2 }} -->
        </div>
        <div class="detail">
          跑步天数：{{ item.run_days }}天 | 每天距离：{{ item.day_distance }}公里
        </div>
        <div class="detail">
          报名人数：{{ item.user_num }}人
        </div>
      </div>
    </div>
    <div v-if="noList" class="empty">暂无班级</div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { NavBar } from 'vant'
import { manageClazzList } from '@/api/clazz_manage'
import img from '@/assets/images/4.jpg'

export default {
  name: 'ClazzManageList',
  components: {
    [NavBar.name]: NavBar
  },
  data () {
    return {
      pageCover: img,
      isLoad: false,
      list: []
    }
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ]),
    noList () {
      return this.isLoad && !this.list.length
    }
  },
  created () {
    this.getClazzList()
  },
  methods: {
    async getClazzList () {
      let response = await manageClazzList()
      this.isLoad = true
      this.list = response.data
    },
    gotoManageClazz (clazz) {
      this.$router.push('/manage/clazz/' + clazz.uuid)
    }
  }
}
</script>

<style scoped lang="scss">
.clazz_manage_list {
  .page_cover {
    width: 750px;
    height: 330px;
    background-size: cover;
    color: #fff;
    font-size: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    .my {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .headimg {
      width: 110px;
      height: 110px;
      border: 2PX solid #fff;
      border-radius: 50%;
      margin-bottom: 20px;
    }
  }
  .clazz_panel {
    width: 680px;
    height: 200px;
    margin: 35px 0 0 35px;
    background-size: cover;
    background-position:center;
    position: relative;
    color: #fff;
    .bg {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background:rgba(0,0,0,0.6);
    }
    .title {
      font-size: 30px;
      font-weight: bold;
      margin-top: 12px;
      margin-left: 30px;
    }
    .detail {
      font-size: 23px;
      color: rgb(226, 221, 221);
      margin-top: 10px;
      margin-left: 30px;
    }
  }
}
.empty {
  color: #969696;
  font-size: 28px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
